import { MINIMUM_SEARCH_LENGTH } from '../constants';

export const isSearchStringValid = (query: string) => {
  return query.length >= MINIMUM_SEARCH_LENGTH;
};
